(() => {
  if (customElements.get('mbs-product')) return;
  class MbsProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-mbs-variants]').textContent);
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-mbs-variant]');
      this.variantInput.disabled = false;
      this.fields = [...this.querySelectorAll('[data-option-index]')];
      this.addButton = this.querySelector('[data-mbs-add]');
      this.status = this.querySelector('[data-mbs-status]');
      this.quantity = this.querySelector('[name="quantity"]');
      this.plan = this.querySelector('[data-mbs-plan]');
      this.busy = false;
      this.form.addEventListener('change', () => this.sync());
      this.form.addEventListener('submit', event => this.add(event));
      this.querySelectorAll('[data-show-media]').forEach(button => button.addEventListener('click', () => this.showMedia(button.dataset.showMedia)));
      this.sticky = this.querySelector('[data-mbs-sticky]');
      this.stickyAction = this.querySelector('[data-mbs-sticky-action]');
      this.stickyAction.addEventListener('click', () => {
        if (this.current?.available) this.form.requestSubmit(this.addButton);
        else {
          const target = this.querySelector('[data-mbs-options]') || this.addButton;
          target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
          (target.querySelector('input:not(:disabled)') || target).focus({preventScroll:true});
        }
      });
      if ('IntersectionObserver' in window) {
        this.buyObserver = new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting;
          this.sticky.classList.toggle('is-visible',show);
          this.sticky.inert = !show;
          document.body.classList.toggle('mbs-has-sticky-buy',show);
        },{threshold:0});
        this.buyObserver.observe(this.querySelector('[data-mbs-buy-row]'));
      }
      this.sticky.inert = true;
      this.sync(false);
      if (this.current?.mediaId) this.showMedia(this.current.mediaId);
    }
    disconnectedCallback() {
      this.buyObserver?.disconnect();
      document.body.classList.remove('mbs-has-sticky-buy');
    }
    showMedia(id) {
      const target = this.querySelector(`[data-media-id="${id}"]`);
      if (!target) return;
      this.querySelectorAll('[data-media-id]').forEach(frame => {
        frame.hidden = frame !== target;
        if (frame.hidden) frame.querySelectorAll('video').forEach(video => video.pause());
      });
      this.querySelectorAll('[data-show-media]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.showMedia === String(id))));
    }
    sync(updateUrl = true) {
      const options = this.fields.map(field => field.querySelector('input:checked')?.value);
      this.current = this.fields.length ? this.variants.find(v => v.options.every((o,i) => o === options[i])) : this.variants.find(v => String(v.id) === this.variantInput.value) || this.variants[0];
      const complete = options.every(Boolean);
      this.fields.forEach((field,index) => {
        field.querySelector('[data-selected-option]').textContent = options[index] ? `— ${options[index]}` : '';
        // Only impossible combinations are disabled; sold-out variants remain selectable and labelled.
        field.querySelectorAll('input').forEach(input => {
          input.disabled = !this.variants.some(v => v.options[index] === input.value && v.options.every((o,i) => i === index || !options[i] || o === options[i]));
        });
      });
      const available = !!this.current?.available;
      this.variantInput.value = this.current?.id || '';
      let label = !complete ? 'Kies jouw maten' : !this.current ? 'Deze combinatie bestaat niet' : !available ? 'Uitverkocht' : this.dataset.preorder === 'true' ? 'Plaats je pre-order' : 'In mijn winkelmand';
      this.addButton.disabled = !available || this.busy;
      this.addButton.textContent = this.busy ? 'Even toevoegen…' : label;
      this.stickyAction.textContent = available ? label : 'Kies jouw maat ↑';
      this.stickyAction.disabled = this.busy;
      if (this.current) {
        const planId = this.plan?.value;
        const allocation = planId ? this.current.plans?.find(p => String(p.id) === planId) : null;
        if (planId && !allocation) {
          this.addButton.disabled = true;
          this.stickyAction.disabled = true;
          this.addButton.textContent = 'Deze bestelwijze is niet beschikbaar';
        }
        const money = allocation?.money || this.current.money;
        this.querySelector('[data-mbs-price]').textContent = money;
        this.querySelector('[data-mbs-sticky-price]').textContent = money;
        const compare = this.querySelector('[data-mbs-compare]');
        compare.hidden = !(this.current.comparePrice > (allocation?.price ?? this.current.price));
        compare.textContent = this.current.compare;
        this.quantity.min = this.current.min || 1;
        this.quantity.step = this.current.step || 1;
        if (this.current.max != null) this.quantity.max = this.current.max; else this.quantity.removeAttribute('max');
        if (+this.quantity.value < +this.quantity.min) this.quantity.value = this.quantity.min;
        if (this.current.max != null && +this.quantity.value > this.current.max) this.quantity.value = this.current.max;
        if (updateUrl) {
          const url = new URL(location.href);url.searchParams.set('variant',this.current.id);
          if (planId) url.searchParams.set('selling_plan',planId); else url.searchParams.delete('selling_plan');
          history.replaceState({},'',url);
          if (this.current.mediaId) this.showMedia(this.current.mediaId);
        }
      }
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || !this.current?.available || !this.form.reportValidity()) return;
      this.busy=true;this.status.textContent='';this.sync(false);
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.().map(item => item.section);
      const data = new FormData(this.form);
      if (sections) {data.append('sections',sections.join(','));data.append('sections_url',location.pathname);}
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Accept':'application/json'},body:data});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'Toevoegen is niet gelukt. Controleer je keuze en probeer opnieuw.');
        const giftResult = await window.MBSGift?.sync?.();
        const renderedResult = giftResult?.sections ? giftResult : result;
        this.status.textContent='Toegevoegd aan je winkelmand.';
        if (drawer && sections?.every(id => renderedResult.sections?.[id])) {
          drawer.setActiveElement?.(this.addButton);
          try {drawer.renderContents(renderedResult);} catch (_) {location.assign(`${root}cart`);}
        } else location.assign(`${root}cart`);
      } catch (error) {
        this.status.textContent=error instanceof TypeError ? 'De verbinding is onderbroken. Controleer je winkelmand voordat je opnieuw probeert.' : error.message;
        this.status.focus({preventScroll:true});
      } finally {this.busy=false;this.sync(false);}
    }
  }
  customElements.define('mbs-product',MbsProduct);
})();
